const CRYPTO_VALUE_DEFAULT_DECIMAL_PRECISION = 6;

interface CryptoFormatOptions {
  truncate?: boolean;
  precision?: number;
  trimTrailingZeros?: boolean;
}

export const formatCryptoAmountWithSymbolAtEnd = (
  amount: string,
  cryptoCurrencyCode: string,
  options: CryptoFormatOptions = { truncate: true },
) => {
  if (options.truncate === false) {
    return `${amount} ${cryptoCurrencyCode}`;
  }

  const numericAmount = parseFloat(amount);
  const precision = options.precision ?? CRYPTO_VALUE_DEFAULT_DECIMAL_PRECISION;
  const trimTrailingZeros = options.trimTrailingZeros ?? true;

  const fixedAmount = numericAmount.toFixed(precision);
  const truncatedAmount = trimTrailingZeros ? fixedAmount.replace(/\.?0+$/, '') : fixedAmount;

  return `${truncatedAmount} ${cryptoCurrencyCode}`;
};
